import { useEffect } from 'react';
import superagent from 'superagent';
import type { LatLngLiteral } from '../components/Map/types';
import type { Address } from '../reducers/addListing';
import Api from '../api/Api';

const api = new Api(null, superagent);

// When ever the address changes geocode it a call set setResolvedAddress
const usePostcodeAnywhereLookup = (
  addressId: string,
  dispatch: () => {},
  setResolvedAddress: (LatLngLiteral, Address) => void,
  setResolvedAddressError: () => void
) => {
  useEffect(
    () => {
      if (!addressId.length) {
        return;
      }

      api
        .resolveAddress(addressId)
        .then(response => {
          dispatch(
            setResolvedAddress(
              {
                lat: parseFloat(response.lat),
                lng: parseFloat(response.lng)
              },
              {
                houseNo: response.houseNo,
                address1: response.address1,
                address2: response.address2,
                address3: response.address3,
                city: response.city,
                postalCode: response.postalCode,
                country: response.country
              }
            )
          );
        })
        .catch(() => {
          dispatch(setResolvedAddressError());
        });
    },
    [addressId, dispatch, setResolvedAddress, setResolvedAddressError]
  );
};

export default usePostcodeAnywhereLookup;
